import { CommonModule, NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

interface APIResponse {
    userId: string;
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    profilePicture: string | null;
    roleName: string;
    schoolName: string | null;
    status: string;
}

@Component({
    selector: 'app-csq-view-dialog',
    templateUrl: './view-dialog.component.html',
    styleUrls: ['./view-dialog.component.scss'],
    imports: [NgIf, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CSQViewDialogComponent {
    userData: APIResponse;

    constructor(
        public dialogRef: MatDialogRef<CSQViewDialogComponent>,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public user: APIResponse
    ) {
        this.userData = user;
    }

    onCancel(): void {

        const search = this.route.snapshot.queryParamMap.get('search');
        
        if (search) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { search: null },
                queryParamsHandling: 'merge'
            });
        }

        this.dialogRef.close(false);
    }

    getFirstName(user: any): string {
        return user?.['first name'] || '-';
    }
    getLastName(user: any): string {
        return user?.['last name'] || '-';
    }
    getPhoneNumber(user: any): string {
        return user?.['phone number'] || '-';
    }

}